import { lazy, Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import SectionSkeleton from "@/components/SectionSkeleton";
import BackToTop from "@/components/BackToTop";

// Lazy load below-fold components to reduce initial bundle size
const ProblemSection = lazy(() => import("@/components/ProblemSection"));
const WhoItsForSection = lazy(() => import("@/components/WhoItsForSection"));
const WhyErlaraSection = lazy(() => import("@/components/WhyErlaraSection"));
const WhatCountsSection = lazy(() => import("@/components/WhatCountsSection"));
const FeaturesSection = lazy(() => import("@/components/FeaturesSection"));
const MicroScenarioSection = lazy(() => import("@/components/MicroScenarioSection"));
const JourneySection = lazy(() => import("@/components/JourneySection"));
const StatsSection = lazy(() => import("@/components/StatsSection"));
const BlogPreviewSection = lazy(() => import("@/components/BlogPreviewSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const FounderSection = lazy(() => import("@/components/FounderSection"));
const CTASection = lazy(() => import("@/components/CTASection"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  const location = useLocation();

  // Handle hash scrolling when navigating from another page
  useEffect(() => {
    if (location.hash) {
      // Small delay to ensure lazy-loaded components are rendered
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen">
      <Navigation />
      <main>
        <HeroSection />
        <Suspense fallback={<SectionSkeleton />}>
          <ProblemSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <WhoItsForSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <WhyErlaraSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <WhatCountsSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton variant="cards" />}>
          <FeaturesSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <MicroScenarioSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <JourneySection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton variant="stats" />}>
          <StatsSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton variant="cards" />}>
          <BlogPreviewSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton variant="faq" />}>
          <div id="faq">
            <FAQSection />
          </div>
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <FounderSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton variant="cta" />}>
          <CTASection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
      <BackToTop />
    </div>
  );
};

export default Index;
